import React from 'react';
import Hero from './components/women-cell/Hero';
import Main from './components/women-cell/Main';

const WomenCell = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default WomenCell;